import { ORDER_STATUS_PIPELINE } from "../constants.js";
export const getOrderStatusPipelineStage = (pipelines) => {
    const orderPipeline = pipelines?.find(({ pipeline }) => pipeline.name === ORDER_STATUS_PIPELINE.NAME);
    if (!orderPipeline)
        return;
    return orderPipeline.pipeline.stages?.find((stages) => stages.id === orderPipeline.stageId)?.name;
};
